export const ratePlanCodes = {
  canada_cricket_mo: 'ca-recu-ga-crick_sportsp-mo-nt-v1',
  canada_cricket_qt: 'ca-recu-ga-crick_sportsp-qt-nt-v2',
  canada_cricket_yr: 'ca-recu-ga-crick_sportsp-yr-nt-v2',
  canada_cricket_elite_mo: 'ca-rc-ga-cricket_elite-mo-nt-1',
  canada_cricket_elite_qt: 'ca-rc-ga-cricket_elite-qt-nt-1',
  canada_cricket_elite_yr: 'ca-rc-ga-cricket_elite-yr-nt-1',
  canada_ent_mo: 'ca-recu-ga-entertainment-mo-7d-v2',
  canada_ent_qt: 'ca-recu-ga-entertainment-qt-7d-v2',
  canada_premium_mo: 'ca-recu-ga-premium-mo-nt-v2',
  canada_premium_qt: 'ca-recu-ga-premium-qt-nt-v1',
  canada_premium_yr: 'ca-recu-ga-premium-yr-nt-v2',
  canada_sports_mo: 'ca-recu-ga-sports-mo-nt-4amtoff1-v1',
  canada_sports_qt: 'ca-rc-ga-sports-qt-nt-39a1-1',
  canada_sports_yr: 'ca-recu-ga-sports-yr-nt-63amtoff1-v1',
  canada_mlb_tv_mo: 'ca-rc-ga-mlbtv-mo-5d-1',
  canada_mlb_tv_yr: 'ca-rc-ga-mlbtv-yr-5d-1',
  elite: 'us-rc-ga-elite_novip-mo-5d-30a1-3',
  essential: 'us-recu-ga-essential-mo-5d-35amtoff1-v1',
  latino: 'us-recu-ga-latino-mo-5d-5amtoff1-v1',
  latino_baseball_1rsn: 'us-recu-mk-latinobb-1rsn-mo-5d-8amtoff1-v1',
  latino_baseball_2rsn: 'us-recu-mk-latinobb-2rsn-mo-5d-10amtoff1-v1',
  pro: 'us-rc-ga-pro-mo-5d-25a1-1',
  zee_family_mo: 'us-rc-ga-willow_zee-mo-nt-5amtoff-v1',
  zee_family_qt: 'us-rc-ga-willow_zee-qt-nt-15amtoff-v1',
  // zee_family_yr: 'us-recu-ga-zee_fam-yr-nt-v1',
  mlbtv_mo: 'us-rc-ga-mlbtv-mo-5d-1',
  masn_plus: 'us-rc-ga-masn-mo-nt-5a1-1',
  rangers_sports_network: 'us-rc-mk-txsrngrs-mo-5d-1',
  latino_masn_plus: 'us-rc-ga-latinobb_masn-mo-nt-8a1-v1',
  chicago_sports_network_mo: 'us-rc-ga-chi_sports-mo-5d-5a1-1',
  marquee_mo: 'us-rc-ga-marquee-mo-5d-5a1-1',
  fubo_sports_monthly: 'us-rc-ga-sports_news-mo-5d-10a1-1',
  canada_sports_pro_mo: 'ca-rc-ga-sports_pro-mo-nt-20a1-1',
  canada_sports_pro_abm: 'ca-rc-ga-sports_pro-12m-nt-10a1-1',
  canada_sports_pro_qt: 'ca-rc-ga-sports_pro-qt-nt-15a1-1',
  canada_sports_pro_yr: 'ca-rc-ga-sports_pro-yr-nt-1',
  starz_mo: 'us-rc-ga-starz-mo-nt-1',
  mgm_plus_mo: 'us-rc-ga-mgm-mo-nt-1',
  paramount_with_showtime_mo: 'us-recu-ga-showtime-mo-nt-v1',
  hallmark_plus_mo: 'us-recu-ga-hallmark_plus-mo-7d-v1',
  dazn_mo: 'us-rc-ga-dazn-mo-nt-1',
  nba_tv_mo: 'us-rc-ga-nba_tv-mo-5d-1',
  fox_nation_mo: 'us-rc-ga-fox_nation-mo-5d-1',
  bein_sports_mo: 'us-rc-ga-bein_sports-mo-nt-1',
}
